// extracted by mini-css-extract-plugin
export default {"checkbox":"SuperCheckbox_checkbox__iiWKS","spanClassName":"SuperCheckbox_spanClassName__qM8QU"};